export default {
      id: "back-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#back",
      toString: function () {
        return this.url;
      }
    }